import React from "react";
import BestPriceImg from "../../../../assets/img/best-price-guaranty.png";
import ChatSupportImg from "../../../../assets/img/chat-support.png";
import SecureOnlineImg from "../../../../assets/img/secure-online.png";

export const HotelSearchFooter = () => {
  return (
    <div className="hw-whyChoose--section hw-pt--medium">
      <div className="hw-page--width">
        <h2 className="h3 text-center mb-20">Why Choose Us?</h2>
        <div className="row hw-gapx10">
          <div className="col-sm-6 col-md-4">
            <div className="hw-2col--grid hw-gapy10">
              <img width={45} height={45} src={BestPriceImg} alt="image" />
              <div className="hw-black hw-text20 hw-fontBold">
                Best Price Guaranty
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-4">
            <div className="hw-2col--grid hw-gapy10">
              <img width={45} height={45} src={ChatSupportImg} alt="image" />
              <div className="hw-black hw-text20 hw-fontBold">
                24x7 Live Chat Support
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="hw-2col--grid hw-gapy10">
              <img width={45} height={45} src={SecureOnlineImg} alt="image" />
              <div className="hw-black hw-text20 hw-fontBold">
              Secure Online Transaction 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
